import useAnalytics from "@hooks/useAnalytics";
import useApiFetch from "@hooks/useApiFetch";
import useClientContext, { setModal } from "@hooks/useClientContext";
import { useRouter } from "next/dist/client/router";
import { useMutation, useQueryClient } from "react-query";
import { pxToRem } from "src/styles/styleUtils";
import { css } from "styled-components";
import { ChaseErrorArea, ChaseSubmitBtn } from "./Form";
import Modal, {
  ChaseContentContainer,
  ChaseHeaderContent,
  ChaseModalWrapper,
  playoffsModalCSS,
} from "./Modal";

export default function LeaveLeagueModal() {
  const [{ openModal }, dispatch] = useClientContext();
  const { fetchApiEndpoint } = useApiFetch();
  const queryClient = useQueryClient();
  const router = useRouter();
  const { trackEvent } = useAnalytics();

  const { league } = openModal.options;
  const leagueName = league?.name || "";
  const leagueId = league?.id;
  const defaultError = "Something went wrong. Please try again.";
  const shouldRenderModal = league && openModal.name === "LEAVE_LEAGUE";

  function leaveLeague() {
    return fetchApiEndpoint(`/api/v1/chase/leagues/${leagueId}/leave.json`, {
      headers: { "content-type": "application/json" },
      method: "DELETE",
    });
  }

  const mutation = useMutation(leaveLeague, {
    onSuccess: () => {
      setTimeout(() => {
        dispatch(setModal(null));
        router.push("/leagues");
        queryClient.invalidateQueries(["league", leagueId]);
        queryClient.invalidateQueries("my-leagues");
      }, 1000);
      trackEvent("leagues:leave");
    },
  });
  const { isError, error } = mutation;

  return shouldRenderModal ? (
    <Modal aria-label="Leave League Dialog" css={modalCSS}>
      <ChaseModalWrapper>
        <ChaseContentContainer>
          <ChaseHeaderContent>
            <h2>Leave League</h2>
            <p>
              Are you sure you want to leave &ldquo;<span>{leagueName}</span>&rdquo;?
            </p>
            <ChaseSubmitBtn onClick={() => mutation.mutate()}>Leave League</ChaseSubmitBtn>
            {isError && <ChaseErrorArea>{`${error || defaultError}`}</ChaseErrorArea>}
          </ChaseHeaderContent>
        </ChaseContentContainer>
      </ChaseModalWrapper>
    </Modal>
  ) : null;
}

const modalCSS = css`
  ${playoffsModalCSS}

  .closeIcon {
    top: ${pxToRem(3)};
    right: ${pxToRem(2)};
    svg {
      width: ${pxToRem(14)};
    }
  }
`;
